(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-x-get-y-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
      // A single, fixed attribute key rather than one key per trigger
      // product: the bxgy-function discount function's input query can only
      // read a cart attribute by an exact, hardcoded key (Shopify Functions
      // can't enumerate "all attributes matching a prefix"), so every
      // trigger's bundle data has to live under one well-known key for the
      // function to find it at all.
      var BUNDLE_MAP_ATTRIBUTE_KEY = '_bxgy_bundle_map';

      // Shopify's javascript tag bundler compiles dynamic import() calls
      // into require(...) for this script's output format, and there's no
      // require() in the browser here — the theme uses native ES module
      // import maps instead, not CommonJS. A real import() only works from
      // inside a genuine <script type="module">, so this injects one at
      // runtime (bundled scripts never touch DOM created after page load),
      // letting the browser's own module loader resolve the theme's
      // "cart-store" import map entry and hand back the live Cart singleton.
      var cartStorePromise = null;
      function getCartStore() {
        if (cartStorePromise) return cartStorePromise;
        cartStorePromise = new Promise(function (resolve, reject) {
          var settled = false;
          function onReady() {
            if (settled) return;
            settled = true;
            document.removeEventListener('bxgy:cart-store-ready', onReady);
            resolve(window.__bxgyCartStore);
          }
          document.addEventListener('bxgy:cart-store-ready', onReady);
          var script = document.createElement('script');
          script.type = 'module';
          script.textContent =
            'import Cart from "cart-store";' +
            'window.__bxgyCartStore = Cart;' +
            'document.dispatchEvent(new CustomEvent("bxgy:cart-store-ready"));';
          document.head.appendChild(script);
          setTimeout(function () {
            if (settled) return;
            settled = true;
            document.removeEventListener('bxgy:cart-store-ready', onReady);
            reject(new Error('Timed out loading cart-store'));
          }, 4000);
        });
        return cartStorePromise;
      }

      // The cart-attribute-based auto-removal watcher (remove the add-ons
      // when the trigger product leaves the cart) now lives in
      // assets/custom.js instead of here. This snippet's own compiled
      // javascript-block bundle only loads on pages that actually render
      // this snippet (the one product page with the widget), so a watcher
      // defined here never ran when the trigger was removed from the cart
      // drawer on a different page, or from the standalone /cart page —
      // custom.js loads unconditionally on every page via layout/theme.liquid
      // and has no such gate.

      function initBxgy(root) {
        if (root.dataset.bxgyInit) return;
        root.dataset.bxgyInit = 'true';

        var submitBtn = root.querySelector('[data-bxgy-submit]');
        var staged = root.querySelector('[data-bxgy-staged]');
        var message = root.querySelector('[data-bxgy-message]');
        var list = root.querySelector('[data-bxgy-list]');
        var fade = root.querySelector('[data-bxgy-fade]');
        var dotsWrap = root.querySelector('[data-bxgy-dots]');
        var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-bxgy-dot]')) : [];
        var redirectToCart = root.dataset.redirectToCart === 'true';

        if (list) {
          // overscroll-behavior: contain (in the stylesheet) is supposed to
          // fully stop scroll chaining at this list's own boundary, but in
          // practice some chaining still leaks through here into the page —
          // specifically while the list is embedded in the theme's
          // <sticky-scroll> buy-box column. That column tracks window.scrollY
          // itself (assets/sticky-scroll.js) and repositions its own `top`
          // based on the delta since its last tick; a few leaked pixels of
          // chained scroll at the exact moment the list hits its bottom edge
          // is enough to confuse that delta math and make the sticky column
          // (and this widget with it) visibly snap back toward its resting
          // position — which is what reads as "jumps to the top", and why
          // it only happened scrolling down (the list starts at its top
          // edge, so a down gesture is the one that can run past the list's
          // far boundary) and never on a scrollbar drag (dragging can't
          // overshoot the track, so there's nothing to chain).
          //
          // This backstop makes chaining impossible rather than relying on
          // the browser to contain it: it only ever calls preventDefault()
          // at the exact instant a gesture would overshoot the list's start
          // or end, and does nothing otherwise — unlike an earlier version
          // of this handler, it never substitutes its own scrollTop math for
          // a normal in-bounds scroll, so native trackpad/wheel momentum is
          // untouched everywhere except that one boundary instant.
          // A 1px tolerance here previously missed real boundary hits on
          // displays with fractional device-pixel-ratio scaling, where
          // scrollHeight/scrollTop/clientHeight round to values a couple of
          // pixels off from the true edge — letting chaining slip through
          // undetected. 2px is the commonly used safe margin for this exact
          // comparison.
          list.addEventListener('wheel', function (event) {
            var atTop = list.scrollTop <= 2;
            var atBottom = list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
            if ((event.deltaY < 0 && atTop) || (event.deltaY > 0 && atBottom)) {
              event.preventDefault();
            }
          }, { passive: false });

          var updateScrollState = function () {
            if (fade) {
              var hasMoreBelow = list.scrollHeight - list.scrollTop - list.clientHeight > 1;
              fade.classList.toggle('is-visible', hasMoreBelow);
            }
            if (dots.length > 1 && list.clientWidth > 0) {
              var page = Math.round(list.scrollLeft / list.clientWidth);
              dots.forEach(function (dot, i) {
                dot.classList.toggle('is-active', i === page);
              });
            }
          };
          list.addEventListener('scroll', updateScrollState, { passive: true });
          window.addEventListener('resize', updateScrollState);
          updateScrollState();
        }

        function getMainForm() {
          return document.querySelector('form[action^="/cart/add"], form[action*="/cart/add"]');
        }

        function getMainVariantId() {
          var form = getMainForm();
          if (form) {
            var input = form.querySelector('[name="id"]');
            if (input && input.value) return input.value;
          }
          return null;
        }

        function getMainQuantity() {
          var form = getMainForm();
          if (form) {
            var input = form.querySelector('[name="quantity"]');
            if (input && input.value) return parseInt(input.value, 10) || 1;
          }
          return 1;
        }

        function setBusy(isBusy) {
          submitBtn.disabled = isBusy;
        }

        function addViaFetch(items) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (response) {
            if (!response.ok) {
              return response.json().then(function (err) {
                throw new Error(err.description || err.message || 'Could not add items to cart.');
              });
            }
            return response.json();
          });
        }

        function tagBundle(Cart, triggerVariantId, addonVariantIds) {
          var currentAttributes = (Cart.getState().cart && Cart.getState().cart.attributes) || {};
          var bundleMap = {};
          try {
            bundleMap = JSON.parse(currentAttributes[BUNDLE_MAP_ATTRIBUTE_KEY] || '{}');
          } catch (e) {}
          var existing = bundleMap[triggerVariantId] || [];
          var merged = existing.concat(addonVariantIds).map(String);
          merged = merged.filter(function (id, index) { return merged.indexOf(id) === index; });
          bundleMap[triggerVariantId] = merged;
          var attributes = Object.assign({}, currentAttributes);
          attributes[BUNDLE_MAP_ATTRIBUTE_KEY] = JSON.stringify(bundleMap);
          return Cart.update({ attributes: attributes });
        }

        function addItems(mainVariantId, mainQuantity, addonVariantIds) {
          // Routes through the theme's own cart-store so the header cart
          // icon and any cart drawer update immediately, the same as a
          // native add-to-cart. Falls back to a plain Ajax cart call (items
          // still get added, just without the live UI refresh, and without
          // the auto-remove tagging) if that can't be loaded for any reason.
          //
          // Whether to include the main/trigger product is decided from the
          // live cart state, not unconditionally: if it's already in the
          // cart (added manually, or from an earlier click of this same
          // button), adding it again would double it up. Only the add-ons
          // that aren't already present get queued too, so re-clicking with
          // the same selection is a no-op rather than piling up duplicates.
          //
          // Added one at a time (not a single batched call with all items)
          // because the theme's cart drawer hydrates each newly-inserted row
          // client-side, and that appears to only be reliably exercised one
          // new row at a time by the theme's own native add-to-cart flow.
          return getCartStore()
            .then(function (Cart) {
              var cartItems = (Cart.getState().cart && Cart.getState().cart.items) || [];
              var presentVariantIds = {};
              cartItems.forEach(function (item) {
                presentVariantIds[String(item.variant_id)] = true;
              });

              var items = [];
              if (!presentVariantIds[String(mainVariantId)]) {
                items.push({ id: parseInt(mainVariantId, 10), quantity: mainQuantity });
              }
              addonVariantIds.forEach(function (variantId) {
                if (presentVariantIds[String(variantId)]) return;
                items.push({ id: parseInt(variantId, 10), quantity: 1 });
              });

              if (items.length === 0) return Promise.resolve();
              return items
                .reduce(function (chain, item) {
                  return chain.then(function () { return Cart.add(item); });
                }, Promise.resolve())
                .then(function () { return tagBundle(Cart, mainVariantId, addonVariantIds); });
            })
            .catch(function () {
              var items = [{ id: parseInt(mainVariantId, 10), quantity: mainQuantity }];
              addonVariantIds.forEach(function (variantId) {
                items.push({ id: parseInt(variantId, 10), quantity: 1 });
              });
              return addViaFetch(items);
            });
        }

        function setMessage(text, state) {
          message.textContent = text || '';
          if (state) {
            message.setAttribute('data-state', state);
          } else {
            message.removeAttribute('data-state');
          }
        }

        // Mirrors the native <product-form>'s notify-on-add behavior
        // (assets/product-form.js) so adding through this widget opens the
        // cart drawer/notification exactly like a normal add-to-cart does.
        // This widget calls Cart.add() directly instead of submitting a
        // <product-form>, so that component's own post-add drawer-opening
        // code never runs unless replicated here.
        function openCartNotification() {
          var cart = document.querySelector('.modal--cart, .popup--cart-notification');
          if (!cart) return;
          if (!cart.shown) {
            cart.open();
          } else if (cart.interval) {
            cart.interval.reset();
            cart.interval.start();
          }
        }

        submitBtn.addEventListener('click', function () {
          var addons = root.querySelectorAll('[data-bxgy-addon]:checked');
          if (addons.length === 0) {
            setMessage('Select an item above to add it to your order.', 'error');
            return;
          }

          var mainVariantId = getMainVariantId();
          if (!mainVariantId) {
            setMessage('Please select the product options above before adding to cart.', 'error');
            return;
          }

          var addonVariantIds = Array.prototype.map.call(addons, function (input) { return input.dataset.variantId; });

          setBusy(true);
          setMessage('', null);
          if (staged) staged.setState('DOING');

          addItems(mainVariantId, getMainQuantity(), addonVariantIds)
            .then(function () {
              if (redirectToCart) {
                window.location.href = '/cart';
                return;
              }
              if (staged) staged.setState('DONE');
              getCartStore()
                .then(function (Cart) { return Cart.resetVariantsBeingAdded(); })
                .catch(function () {})
                .then(openCartNotification);
            })
            .catch(function (error) {
              setMessage((error && error.message) || 'Something went wrong. Please try again.', 'error');
              if (staged) staged.setState('IDLE');
            })
            .finally(function () {
              setBusy(false);
            });
        });
      }

      document.querySelectorAll('[data-bxgy]').forEach(initBxgy);
      document.addEventListener('shopify:section:load', function (event) {
        var root = event.target.querySelector('[data-bxgy]');
        if (root) initBxgy(root);
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
